// import React, { useEffect, useRef } from "react";
// import "./AutodeskViewer.css";

// const AutodeskViewer = ({
//   documentId,
//   accessToken,
//   loading,
//   onViewerReady,
//   onDocumentLoaded,
//   onError,
//   onLoadingChange,
//   extensions,
// }) => {
//   const viewerDiv = useRef(null);
//   const viewerRef = useRef(null);

//   useEffect(() => {
//     if (window.Autodesk && viewerDiv.current && !viewerRef.current) {
//       initializeViewer();
//     }

//     return () => {
//       if (viewerRef.current) {
//         try {
//           // Clean up global reference
//           if (window.__autodeskViewer === viewerRef.current) {
//             window.__autodeskViewer = null;
//           }
//           viewerRef.current.finish();
//           viewerRef.current = null;
//         } catch (error) {
//           console.warn("Error during cleanup:", error);
//         }
//       }
//     };
//   }, []);

//   useEffect(() => {
//     if (viewerRef.current && documentId && accessToken) {
//       loadDocument();
//     }
//   }, [documentId, accessToken]);

//   const initializeViewer = () => {
//     const options = {
//       env: "AutodeskProduction",
//       api: "derivativeV2",
//       getAccessToken: (onTokenReady) => {
//         console.log("Getting access token...");
//         if (accessToken) {
//           onTokenReady(accessToken, 3600);
//         }
//       },
//     };

//     window.Autodesk.Viewing.Initializer(options, () => {
//       console.log("Autodesk viewer initializer callback");
//       const viewer = new window.Autodesk.Viewing.GuiViewer3D(viewerDiv.current);
//       const startedCode = viewer.start();

//       if (startedCode > 0) {
//         console.error("WebGL not supported, startedCode:", startedCode);
//         onError?.("WebGL is not supported in this browser");
//         return;
//       }

//       viewerRef.current = viewer;

//       // ── Expose viewer globally so IssueSidebarBridge can disable
//       //    the built-in context menu via viewer.setContextMenu(null)
//       window.__autodeskViewer = viewer;

//       // console.log(viewer);
//       onViewerReady?.(viewer);

//       // Load extensions
//       if (extensions?.NestedViewer) {
//         console.log(
//           "=-=-=-=-=-=-=-=-=-=-=-NestedViewerExtension loaded!-=-=-=-=-=-=-=-=-=-=-",
//         );
//         viewer.loadExtension(
//           extensions.NestedViewer.id,
//           extensions.NestedViewer.options || {},
//         );
//       }

//       if (extensions?.PushpinVEContainer) {
//         viewer.loadExtension(
//           extensions.PushpinVEContainer.id,
//           extensions.PushpinVEContainer.options || {},
//         );
//         console.log("PushpinVEContainer extension loaded!");
//       }

//       if (documentId) {
//         loadDocument();
//       }
//     });
//   };

//   const loadDocument = () => {
//     const viewer = viewerRef.current;
//     if (!viewer || !documentId) {
//       // console.log("Cannot load document - missing viewer or documentId");
//       return;
//     }

//     const documentUrn = `urn:${documentId}`;
//     // console.log("Loading document URN:", documentUrn);
//     onLoadingChange?.(true);

//     window.Autodesk.Viewing.Document.load(
//       documentUrn,
//       (doc) => {
//         // console.log("Document loaded successfully");

//         const root = doc.getRoot();
//         const defaultModel = root.getDefaultGeometry();

//         if (defaultModel) {
//           // console.log("Default geometry:", defaultModel);
//         }

//         const allChildren = root.getChildren
//           ? root.getChildren()
//           : root.children;
//         // console.log("Children nodes:", allChildren);

//         if (allChildren && allChildren.length) {
//           allChildren.forEach((node) => {
//             // console.log(
//             //   "Node name:",
//             //   node.getName ? node.getName() : node.name,
//             // );
//             // console.log(
//             //   "Node type:",
//             //   node.getType ? node.getType() : node.type,
//             // );
//           });
//         }

//         if (defaultModel) {
//           // console.log("Loading geometry...");
//           viewer
//             .loadDocumentNode(doc, defaultModel)
//             .then(() => {
//               // console.log("Geometry loaded successfully");.
//               onLoadingChange?.(false);
//               onDocumentLoaded?.(doc);
//             })
//             .catch((error) => {
//               console.error("Failed to load geometry:", error);
//               onLoadingChange?.(false);
//               onError?.("Failed to load geometry: " + error.message);
//             });
//         } else {
//           console.error("No viewable content found");
//           onLoadingChange?.(false);
//           onError?.("No viewable content found in the document");
//         }
//       },
//       (errorCode, errorMsg) => {
//         console.error("Failed to load document:", errorCode, errorMsg);
//         onLoadingChange?.(false);
//         onError?.(`Failed to load document: ${errorMsg} (${errorCode})`);
//       },
//     );
//   };

//   return (
//     <div className="autodesk-viewer">
//       {loading && (
//         <div className="loading-overlay">
//           <div className="spinner"></div>
//           <p>Loading model...</p>
//         </div>
//       )}
//       <div ref={viewerDiv} className="viewer-element" />
//     </div>
//   );
// };

// export default AutodeskViewer;

import React, { useEffect, useRef } from "react";
import "./AutodeskViewer.css";

const AutodeskViewer = ({
  documentId,
  accessToken,
  loading,
  onViewerReady,
  onDocumentLoaded,
  onError,
  onLoadingChange,
  extensions,
}) => {
  const viewerDiv = useRef(null);
  const viewerRef = useRef(null);

  // Refs, որոնք միշտ պահում են props-երի ընթացիկ արժեքը
  const accessTokenRef = useRef(accessToken);
  const extensionsRef = useRef(extensions);
  const documentIdRef = useRef(documentId);

  useEffect(() => {
    accessTokenRef.current = accessToken;
    extensionsRef.current = extensions;
    documentIdRef.current = documentId;
  }); // dependency array-ի բացակայությունը դիտավորյալ է. ամեն render-ում թարմացվում է

  useEffect(() => {
    if (window.Autodesk && viewerDiv.current && !viewerRef.current) {
      initializeViewer();
    }

    return () => {
      if (viewerRef.current) {
        try {
          if (window.__autodeskViewer === viewerRef.current) {
            window.__autodeskViewer = null;
          }
          viewerRef.current.finish();
          viewerRef.current = null;
        } catch (error) {
          console.warn("Error during cleanup:", error);
        }
      }
    };
  }, []);

  useEffect(() => {
    if (viewerRef.current && documentId && accessToken) {
      loadDocument();
    }
  }, [documentId, accessToken]);

  const initializeViewer = () => {
    const options = {
      env: "AutodeskProduction",
      api: "derivativeV2",
      getAccessToken: (onTokenReady) => {
        console.log("Getting access token...");
        // ref-ից՝ ընթացիկ (ոչ թե stale) արժեքը
        if (accessTokenRef.current) {
          onTokenReady(accessTokenRef.current, 3600);
        }
      },
    };

    window.Autodesk.Viewing.Initializer(options, () => {
      console.log("Autodesk viewer initializer callback");
      const viewer = new window.Autodesk.Viewing.GuiViewer3D(viewerDiv.current);
      const startedCode = viewer.start();

      if (startedCode > 0) {
        console.error("WebGL not supported, startedCode:", startedCode);
        onError?.("WebGL is not supported in this browser");
        return;
      }

      viewerRef.current = viewer;
      window.__autodeskViewer = viewer;
      onViewerReady?.(viewer);

      const currentExtensions = extensionsRef.current;

      if (currentExtensions?.NestedViewer) {
        console.log(
          "NestedViewer extension loading:",
          currentExtensions.NestedViewer.id,
        );
        viewer.loadExtension(
          currentExtensions.NestedViewer.id,
          currentExtensions.NestedViewer.options || {},
        );
      }

      if (currentExtensions?.PushpinVEContainer) {
        viewer.loadExtension(
          currentExtensions.PushpinVEContainer.id,
          currentExtensions.PushpinVEContainer.options || {},
        );
        console.log("PushpinVEContainer extension loaded!");
      }

      if (documentIdRef.current) {
        loadDocument();
      }
    });
  };

  const loadDocument = () => {
    const viewer = viewerRef.current;
    if (!viewer || !documentId) return;

    const documentUrn = `urn:${documentId}`;
    onLoadingChange?.(true);

    window.Autodesk.Viewing.Document.load(
      documentUrn,
      (doc) => {
        const root = doc.getRoot();
        const defaultModel = root.getDefaultGeometry();

        if (defaultModel) {
          viewer
            .loadDocumentNode(doc, defaultModel)
            .then(() => {
              onLoadingChange?.(false);
              onDocumentLoaded?.(doc);
            })
            .catch((error) => {
              console.error("Failed to load geometry:", error);
              onLoadingChange?.(false);
              onError?.("Failed to load geometry: " + error.message);
            });
        } else {
          console.error("No viewable content found");
          onLoadingChange?.(false);
          onError?.("No viewable content found in the document");
        }
      },
      (errorCode, errorMsg) => {
        console.error("Failed to load document:", errorCode, errorMsg);
        onLoadingChange?.(false);
        onError?.(`Failed to load document: ${errorMsg} (${errorCode})`);
      },
    );
  };

  return (
    <div className="autodesk-viewer">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Loading model...</p>
        </div>
      )}
      <div ref={viewerDiv} className="viewer-element" />
    </div>
  );
};

export default AutodeskViewer;
